import { useIntl } from 'react-intl';

import { BulbIcon } from '@/components/icons/bulb';
import { LightningBoltIcon } from '@/components/icons/lightning-bolt';

export type RecommendationType = 'sourcing' | 'automation';

export const useRecommendationContent = () => {
  const intl = useIntl();

  const getRecommendationContent = (
    type: RecommendationType,
    value?: number,
  ) => {
    switch (type) {
      case 'sourcing': {
        return {
          icon: BulbIcon,
          headerText: intl.formatMessage({
            defaultMessage: 'Start Sourcing',
          }),
          title: intl.formatMessage(
            {
              defaultMessage:
                '{count, plural, one {# live opening not being promoted} other {# live openings not being promoted}}',
            },
            { count: value ?? 0 },
          ),
          description: intl.formatMessage({
            defaultMessage:
              "These openings are active but don't have campaigns running yet.",
          }),
          buttonText: intl.formatMessage({
            defaultMessage: 'Setup sourcing',
          }),
        };
      }
      case 'automation': {
        return {
          icon: LightningBoltIcon,
          headerText: intl.formatMessage({
            defaultMessage: 'Automation Recommendations',
          }),
          title: intl.formatMessage({
            defaultMessage: 'Save money automatically',
          }),
          description: intl.formatMessage({
            defaultMessage:
              'Automations pause campaigns when goals, budgets, or timelines are met.',
          }),
          buttonText: intl.formatMessage({
            defaultMessage: 'Enable automations',
          }),
        };
      }
      default: {
        return null;
      }
    }
  };

  return { getRecommendationContent };
};
